import { Button, FlexBox, Text } from '@dixa/lib-shared-habla';
import { useHasAccess } from 'lib-shared-access-control';
import type { ConversationAutomationAiAgentLogEntry } from 'lib-shared-types-api';
import { useCallback } from 'react';

import { useAppNavigate } from 'utils/url/useAppNavigate';

type RoutedThroughAutomationAiAgentProps = {
  readonly node: ConversationAutomationAiAgentLogEntry;
};

export function RoutedThroughAutomationAiAgent({
  node,
}: RoutedThroughAutomationAiAgentProps): JSX.Element {
  const navigate = useAppNavigate();
  const hasAiAgentReadAccess = useHasAccess([
    'settings.integration.channel.edit',
    'settings.chatbot',
  ]);

  const handleGoToAutomationAiAgent = useCallback(() => {
    if (!node.chatbot_id) return;
    navigate({
      path: '/settings/ai-agents/mim/:id',
      params: {
        path: {
          id: node.chatbot_id,
        },
      },
    });
  }, [navigate, node.chatbot_id]);

  return (
    <FlexBox alignItems="center" gap="200">
      <Text.Paragraph>
        Automation AI agent
        {node.chatbot_name && (
          <>
            : <strong>{node.chatbot_name}</strong>
          </>
        )}{' '}
        {node.exit_reason && (
          <>
            · <strong>{node.exit_reason}</strong>
          </>
        )}
      </Text.Paragraph>
      {hasAiAgentReadAccess && node.chatbot_id && (
        <Button variant="secondary" onClick={handleGoToAutomationAiAgent}>
          Go to Automation AI agent
        </Button>
      )}
    </FlexBox>
  );
}
